import { render, staticRenderFns } from "./OrbitRoundScrollableTable.vue?vue&type=template&id=6fcdf1ce&scoped=true"
import script from "./OrbitRoundScrollableTable.vue?vue&type=script&lang=ts"
export * from "./OrbitRoundScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./OrbitRoundScrollableTable.vue?vue&type=style&index=0&id=6fcdf1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcdf1ce",
  null
  
)

export default component.exports